export type TaskAction = { kind?: string; instrument_id?: string; [k: string]: unknown };
export type TaskUsage = { mode_id: string; criticality: string };

export type Task = {
  task_id: string;
  label: string;
  why?: string;
  category?: string;
  universal?: boolean;
  action?: TaskAction;
  satisfies_panels?: string[];
  used_by?: TaskUsage[];
};

export type TasksResponse = { version: number | string | null; tasks: Record<string, Task> };

export function taskList(r: TasksResponse | undefined): Task[] {
  return r ? Object.values(r.tasks ?? {}) : [];
}

export function filterTasks(list: Task[], query: string): Task[] {
  const q = query.toLowerCase().trim();
  if (!q) return list;
  return list.filter((t) =>
    t.task_id.toLowerCase().includes(q) ||
    (t.label || '').toLowerCase().includes(q) ||
    (t.category || '').toLowerCase().includes(q) ||
    (t.satisfies_panels ?? []).some((p) => p.toLowerCase().includes(q)));
}

/** Render a task's action as a short human string. */
export function taskActionLabel(t: Task): string {
  const a = t.action;
  if (!a) return '—';
  if (a.kind === 'instrument_sheet' && a.instrument_id) return `instrument: ${a.instrument_id}`;
  return a.kind || '—';
}
